module.exports = __webpack_public_path__ + "img/logo-fr.48c29c61.svg";